import { atom } from "jotai";

export const pasoActualAtom = atom(0);
export const formInstanceAtom = atom(undefined);